import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { AppSelector, setCurrentOrganization } from '@core/store';
import { Store } from '@ngrx/store';
import { firstValueFrom } from 'rxjs';

import { ACCOUNT_PATH } from '../../constants';

export const organizationGuard =
	(): CanActivateFn => async (activeRoute: ActivatedRouteSnapshot) => {
		const accountSelector = inject(AppSelector);
		const router = inject(Router);
		const store = inject(Store);

		const { orgId } = activeRoute.params ?? -1;
		const orgIdParam = +orgId;
		if (orgIdParam && Number.isInteger(orgIdParam)) {
			const connectedUser = await firstValueFrom(
				accountSelector.getCurrentUser$(),
			);
			if (!connectedUser.accounts.has(orgIdParam)) {
				store.dispatch(
					setCurrentOrganization({
						orgId: connectedUser.primaryOrganizationId,
					}),
				);
				return router.parseUrl(ACCOUNT_PATH);
			} else {
				store.dispatch(
					setCurrentOrganization({
						orgId: orgIdParam,
					}),
				);
				return true;
			}
		} else {
			return router.parseUrl(ACCOUNT_PATH);
		}
	};
